module.exports = __webpack_public_path__ + "static/media/gaming9.1acdc33c.webp";